import script from "./ProjectCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectCard.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectCard.vue?vue&type=style&index=0&id=65f37b8e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65f37b8e"]])

export default __exports__